import { Grid, useMediaQuery } from "@mui/material";
import { usePostHog } from "posthog-js/react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { openEmployerSignUp } from "../../../helpers/elp_sign_up";
import { fetchEmployerPageEventContent } from "../../../redux/actions/company_action";
import content_event from "./content_event.json";
import content_sg from "./content_sg.json";
import {
  GridStyledHireBetter,
  HireBetterButtonContainer,
  HireBetterCard,
  HireBetterCTA,
  HireBetterDecoTopLeft,
  HireBetterEventDescription,
  HireBetterEventHeadline,
  HireBetterEventName,
  HireBetterImage,
  HireBetterOuterCard,
  HireBetterUpperContainer,
  MerdekaBannerImage,
  MerdekaBannerWrapper,
} from "./styles";

const IS_MALAYSIA = process.env.NEXT_PUBLIC_JSW_GEOLOCATION === "my";

// A missing bound leaves that end of the window open
function isWithinEventWindow(startDate, endDate) {
  const now = Date.now();
  const start = startDate ? new Date(startDate).getTime() : null;
  const end = endDate ? new Date(endDate).getTime() : null;

  if (start && now < start) return false;
  if (end && now > end) return false;

  return true;
}

export default function EmployerHireBetterEvent() {
  const [data, setData] = useState([]);
  const [eventContent, setEventContent] = useState(null);

  const dispatch = useDispatch();

  const belowTablet = useMediaQuery("(max-width: 767px)");
  const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 1199px)");

  async function fetchEventContent() {
    const response = await dispatch(fetchEmployerPageEventContent());

    setEventContent(response || null);
  }

  async function fetchData() {
    // use s3 json for staging testing
    // const content_my_json = await  fetchJsonData(
    //   "https://assets.hiredly.com/cms-staging/json-file/event_banner_content_my.json"
    // );

    // const content_sg_json = await fetchJsonData(
    //   "https://assets.hiredly.com/cms-staging/json-file/event_banner_content_sg.json"
    // );

    // const content_my_new = isStaging ? content_my : content_my_json;
    // const content_sg_new = isStaging ? content_sg : content_sg_json;

    let response;
    if (IS_MALAYSIA) {
      response = content_event;
    } else {
      response = content_sg;
    }

    const { hbhf } = response || {};

    setData(hbhf);
  }

  useEffect(() => {
    fetchData();
    fetchEventContent();
  }, []);

  const onButtonClick = (isEvent, buttonCTA) => {
    triggerEmployerSignUp(buttonCTA);
  };

  const posthog = usePostHog();
  const headlineText = `${data?.eventHeadline || ""} ${
    data?.eventHeadlineMoile || ""
  }`.toLowerCase();

  const cmsWebImage = eventContent?.webImage?.data?.attributes?.url;
  const cmsMobileImage = eventContent?.mobileImage?.data?.attributes?.url;

  // Singapore only inherits this entry when the CMS opts in via syncSg
  const isRegionEligible = IS_MALAYSIA || Boolean(eventContent?.syncSg);

  // fullyCustom hands the slot back to the locally authored JSON layout
  const showCmsEvent =
    !eventContent?.fullyCustom &&
    isRegionEligible &&
    isWithinEventWindow(eventContent?.startDate, eventContent?.endDate) &&
    Boolean(cmsWebImage || cmsMobileImage);

  // Tablet has no dedicated CMS asset, so it shares the web artwork
  const cmsBannerImage = belowTablet
    ? cmsMobileImage || cmsWebImage
    : cmsWebImage || cmsMobileImage;

  const buttonColour = showCmsEvent
    ? eventContent?.buttonColor || "yellow"
    : data?.eventName?.includes("Raya Promo")
    ? "green"
    : data?.eventName?.includes("Mid-Year Sale")
    ? "purple"
    : data?.eventName?.includes("Mega Merdeka Sale")
    ? "orange"
    : "yellow";

  function onCmsEventClick() {
    const customLink = eventContent?.customCtaLink;

    if (customLink) {
      return window.open(customLink);
    }

    triggerEmployerSignUp(eventContent?.ctaButtonCopy);
  }

  function triggerEmployerSignUp(buttonText) {
    openEmployerSignUp({
      posthog,
      buttonCTA: buttonText,
      buttonColour: buttonColour,
      section: "promo",
    });
  }

  if (showCmsEvent) {
    return (
      <GridStyledHireBetter
        id="hbhf"
        isEvent={true}
        sx={{
          background: "transparent",
          borderTop: "none",
          borderBottom: "none",
          height: "auto",
          maxHeight: "none",
          minHeight: "unset",
          padding: "0px !important",
        }}
      >
        <MerdekaBannerWrapper
          type="button"
          onClick={onCmsEventClick}
          aria-label={eventContent?.ctaButtonCopy || "Hiredly employer promo"}
        >
          <MerdekaBannerImage
            src={cmsBannerImage}
            alt={eventContent?.ctaButtonCopy || "Hiredly employer promo"}
          />
        </MerdekaBannerWrapper>
      </GridStyledHireBetter>
    );
  }

  if (data?.sectionTitle) {
    const isEvent = true;
    const ctaCopy = belowTablet
      ? data?.ctaButtonCopyMobile
      : data?.ctaButtonCopy;

    // Determine image URL based on screen size and event type
    const getImageUrl = () => {
      if (belowTablet) {
        return "https://assets.wobbjobs.com/images/employer_landing/labour_day_logo.png";
      }
      return data?.imageUpload?.data?.attributes?.url;
    };

    return (
      <GridStyledHireBetter
        id="hbhf"
        isEvent={isEvent}
        sx={{
          // backgroundImage: `url(${contentBg})`,
          // backgroundSize: "contain", // or 'auto' if you want the image to keep its original size
          // backgroundRepeat: "repeat",
          // backgroundPosition: "center",
          background: `linear-gradient(111deg, #E9503B 47.66%, #5D41BB 86.91%);`,
        }}
      >
        <HireBetterOuterCard isEvent={isEvent}>
          <HireBetterCard isEvent={isEvent}>
            <Grid
              sx={{
                display: "flex",
                justifyContent: "center",
                borderRadius: "16px",
                position: "relative",
              }}
            >
              <HireBetterImage
                isEvent={isEvent}
                src={getImageUrl()}
                width={375}
                height={375}
              />
              <HireBetterDecoTopLeft
                src={`https://assets.wobbjobs.com/images/employer_landing/labour_day_left_asset.png`}
              />
            </Grid>
            <HireBetterUpperContainer isEvent={isEvent}>
              <Grid
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                  width: "100%",
                  alignItems: belowTablet ? "center" : "flex-start",
                }}
              >
                <Grid
                  sx={(theme) => ({
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                    width: "100%",
                    alignItems: belowTablet ? "center" : "flex-start",
                  })}
                >
                  {data?.eventName && (
                    <HireBetterEventName
                      isEvent={isEvent}
                      sx={{
                        "& p": {
                          margin: 0,
                        },
                      }}
                      dangerouslySetInnerHTML={{
                        __html: data?.eventName,
                      }}
                    ></HireBetterEventName>
                  )}
                  <HireBetterEventHeadline
                    isEvent={isEvent}
                    dangerouslySetInnerHTML={{
                      __html: belowTablet
                        ? data?.eventHeadlineMoile
                        : data?.eventHeadline,
                    }}
                  ></HireBetterEventHeadline>
                </Grid>

                <HireBetterEventDescription
                  isEvent={isEvent}
                  dangerouslySetInnerHTML={{
                    __html: data?.eventDescription,
                  }}
                />
              </Grid>
              <HireBetterButtonContainer>
                <HireBetterCTA
                  onClick={() => onButtonClick(isEvent, ctaCopy)}
                  isEvent={isEvent}
                >
                  {isEvent ? (
                    <img
                      src="https://assets.wobbjobs.com/images/employer_landing/labour_day_cta.png"
                      style={{ height: "100%" }}
                    />
                  ) : (
                    <>{ctaCopy}</>
                  )}
                </HireBetterCTA>
              </HireBetterButtonContainer>
            </HireBetterUpperContainer>
          </HireBetterCard>
        </HireBetterOuterCard>
      </GridStyledHireBetter>
    );
  }
}
